module.exports = __webpack_public_path__ + "img/pin-imperial-black-diamond.675e791a.png";